import { useContext } from 'react'
import { Link } from 'react-router-dom'

import AuthContext from 'context/AuthContext'
import { formatNumber } from 'utils/utils'
import { BackArrow } from 'utils/icons'
import ActiveOfferAvatar from 'pages/GamesList/components/redesign/ActiveOfferAvatar'
import { expiresIn } from 'pages/GamesList/components/redesign/InProgress'
import { getCurrentTask } from 'pages/GamesList/components/redesign/offerRewards'

import 'pages/GamesList/components/redesign/index.css'

const Icon = ({ src, alt, size = 18 }) => <img src={src} alt={alt} width={size} height={size} />

const ArchiveIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M3 4h18v4H3zM5 8v12h14V8M10 12h4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * A game in the Library: in Continue (`onArchive` given) it shows the ring, the next reward, the
 * days left and the Archive button, as the home's Continue panel does; in the history just its
 * icon. Both show what the user earned in it.
 */
const LibraryGame = ({ game, onArchive }) => {
  const { user } = useContext(AuthContext)
  const { gameDetails, gameHistory, activatedOffer } = game

  // An archived offer sits in the history, which shows only what the game earned.
  const currentTask =
    onArchive && getCurrentTask(activatedOffer, { hasParsingEnabled: user?.hasParsingEnabled })
  const timeLeft = onArchive && expiresIn(activatedOffer)
  const earnedPiggy = gameHistory?.earnedPiggy ?? 0
  const earnedCoins = gameHistory?.earnedCoins ?? 0

  return (
    <li className={`gameLibraryGame ${onArchive ? 'inProgress' : ''}`}>
      {onArchive ? (
        <ActiveOfferAvatar offer={{ iconUrl: gameDetails.icon_url, activatedOffer }} />
      ) : (
        <img className="gameLibraryGameIcon" src={gameDetails.icon_url} alt="" />
      )}
      <span className="gameLibraryGameDetails">
        <Link className="gameLibraryGameName" to={`/games/${game.unifiedAppId}`}>
          {gameDetails.name}
        </Link>
        {currentTask?.piggyBanks > 0 && (
          <span className="gamesRedesignInProgressNext">
            Up next: {formatNumber(currentTask.piggyBanks)}
            <Icon src="/images/pig.png" alt="piggy banks" size={14} />
          </span>
        )}
        {timeLeft && <span className="gamesRedesignInProgressExpiry">{timeLeft}</span>}
        {onArchive && (
          <button type="button" className="gameLibraryArchive" onClick={() => onArchive(game)}>
            <ArchiveIcon />
            Archive
          </button>
        )}
      </span>
      {(earnedPiggy > 0 || earnedCoins > 0) && (
        <span className="gameLibraryEarned">
          <span className="gameLibraryEarnedLabel">EARNED</span>
          <span className="gameLibraryEarnedPills">
            {earnedPiggy > 0 && (
              <span className="gamesRedesignRewardPill pig">
                <span className="gamesRedesignRewardPillValue">{formatNumber(earnedPiggy)}</span>
                <Icon src="/images/pig.png" alt="piggy banks" />
              </span>
            )}
            {earnedCoins > 0 && (
              <span className="gamesRedesignRewardPill coin">
                <span className="gamesRedesignRewardPillValue">{formatNumber(earnedCoins)}</span>
                <Icon src="/images/coin.png" alt="coins" />
              </span>
            )}
          </span>
        </span>
      )}
      <BackArrow customClassName="gameLibraryChevron" />
    </li>
  )
}

export default LibraryGame
